import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8306a8b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-siren-body-widget" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Base Siren", -1))
const _hoisted_3 = { class: "center-wrapper" }
const _hoisted_4 = { class: "icon" }

import { computed } from 'vue';
import { BaseSirenComposable } from '../../../ecs/types';
import IconComponent from '../../icon/IconComponent.vue';
import { Icon } from '../../icon/Icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSirenBodyWidget',
  props: {
    baseSiren: null
  },
  setup(__props: any) {

const props = __props as {
  baseSiren: BaseSirenComposable;
}



const handleToggleClicked = () => {
  props.baseSiren.toggle();
  props.baseSiren.complete();
};

const message = computed(() => {
  return props.baseSiren.active.value.active
    ? 'Deactivate the alarm'
    : 'Sound the alarm';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["icon-container", {
          active: __props.baseSiren.active.value.active
        }]),
        onClick: handleToggleClicked
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(IconComponent, {
            icon: _unref(Icon).DOUBLE_TRIANGLE_WARNING
          }, null, 8, ["icon"])
        ])
      ], 2),
      _createElementVNode("h5", null, _toDisplayString(_unref(message)), 1)
    ])
  ]))
}
}

})